module.exports = __webpack_public_path__ + "assets/img/media_17.8a72842d.png";